var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form-group",
    {
      attrs: {
        label: "E-mail",
        "label-for": "email",
        description: "Digite seu e-mail"
      }
    },
    [
      _c("b-form-input", {
        attrs: {
          id: "email",
          type: "email",
          placeholder: "email@exemplo.com",
          required: "",
          state: _vm.emailState,
          "aria-describedby": "email-feedback"
        },
        on: { blur: _vm.validateEmail },
        model: {
          value: _vm.email,
          callback: function($$v) {
            _vm.email = $$v
          },
          expression: "email"
        }
      }),
      _vm._v(" "),
      _c("b-form-invalid-feedback", { attrs: { id: "email-feedback" } }, [
        _vm._v("\n    Por favor, insira um e-mail válido.\n  ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }